import type React from 'react'
import SearchResults from '../components/SearchResultsContainer'

const SearchResultPage: React.FC = () => <SearchResults />

export default SearchResultPage
